import { CONFIRM_COLOR, CONFIRM_ICONS, TYPE_MODAL } from '../modal-confirm-notification';

export const DELETE_APPROVAL_RANGE = {
    typeModal: TYPE_MODAL.NOTIFICATION,
    title: 'Al eliminar se perderá los rangos y niveles de aprobación',
    valueButton: 'Eliminar rango',
    color: CONFIRM_COLOR.WARN,
    iconSVG: CONFIRM_ICONS.CANCEL
  };
